export var loadingPlaceholderClassName = 'smart-link-loading-placeholder';